<script lang="ts">
  import { Alert } from '$shared/components';
  import { AlertOption } from '$provider/models/AlertOption';
  import { AtlasMergePrepStatusModel } from '$provider/models/profile/merge/AtlasMergePrepStatusModel';
  import AtlasMergePrepStatus from '$provider/lib/apis/models/AtlasMergePrepStatus';

  interface Props {
    atlasMergePrepStatus: AtlasMergePrepStatusModel;
    onclick?: () => void;
  }

  let { atlasMergePrepStatus, onclick }: Props = $props();

  const description =
    atlasMergePrepStatus.status === AtlasMergePrepStatus.Failed
      ? 'Cred AI Merge Preperation has failed. '
      : 'Cred AI Merge Preperation was completed successfully. ';
  const option =
    atlasMergePrepStatus.status === AtlasMergePrepStatus.Failed
      ? AlertOption.errorAlert(true, 'Why?')
      : AlertOption.infoAlert(true, 'View Steps');
</script>

<div class="alert-out-date">
  <Alert data={description} options={option} maxWidth {onclick} />
</div>
